import LegalDoc from "@/components/LegalDoc";
import { VENDOR_AGREEMENT } from "@/legal/vendor-agreement";

export default function TermsVendor() {
  return (
    <LegalDoc
      doc={VENDOR_AGREEMENT}
      related={[
        { to: "/terms/planner", label: "Customer Terms of Service" },
      ]}
    />
  );
}
